import { AccountApi } from "./AccountApi";

export class AccountApiImpl implements AccountApi {
    private navigate: (path: string) => void;

    constructor(navigate: (path: string) => void) {
        this.navigate = navigate;
    }

    loadLoginScreen(): void {
        this.navigate("/auth");
    }
}